export default class Dog {
  constructor() {
    this._name = 'Dog';
  }
  get name() {
    return this._name;
  }
}



// WEBPACK FOOTER //
// ./src/dog.js